import { render, staticRenderFns } from "./ReviewNewProducts.vue?vue&type=template&id=206b5e0a&scoped=true&"
import script from "./ReviewNewProducts.vue?vue&type=script&lang=js&"
export * from "./ReviewNewProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206b5e0a",
  null
  
)

export default component.exports